import React, {Component} from 'react'
import './Main.MobileStyles.css'
import './Main.Styles.css'
import {IconContext} from 'react-icons'
import {MdAirlineSeatLegroomNormal, MdCheck, MdPregnantWoman} from "react-icons/md"
import {
  FaAppStore,
  FaChartArea,
  FaEgg,
  FaFacebookSquare,
  FaFireAlt,
  FaGooglePlay,
  FaHeartbeat,
  FaInstagram,
  FaTable,
  FaTwitterSquare
} from "react-icons/fa"
import images from "../../images"
import {appStringEn, appStringVi} from "../../appString"
import ScrollMenu from 'react-horizontal-scrolling-menu'
import {
  IoIosArrowBack,
  IoIosArrowForward,
  IoIosBeer,
  IoIosCalculator,
  IoIosWater,
  IoMdBody,
  IoMdCalendar
} from "react-icons/io"
import {GiFat, GiOpenedFoodCan} from "react-icons/gi"
import {FiPercent} from "react-icons/fi"

export default class MainScreen extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isEn: false
    }
  }

  render() {
    return (
      <div className={'viewRoot'}>
        {this.renderHeader()}
        {this.renderDescription()}
        {this.renderFeature()}
        {this.renderScreenshotBody()}
        {this.renderScreenshotNutrition()}
        {this.renderViewContact()}
        {this.renderFooter()}
      </div>
    )
  }

  renderHeader = () => {
    const appString = this.state.isEn ? appStringEn : appStringVi
    return (
      <div className={'viewHeader'}>
        {/*Btn change language*/}
        <button
          className={'btnChangeLanguage'}
          onClick={() => this.setState({isEn: !this.state.isEn})}
        >
          <img
            alt={"flag"}
            className={"imgFlag"}
            src={this.state.isEn ? images.viFlag : images.enFlag}
          />
          <span className={'textBtnChangeLanguage'}>{this.state.isEn ? 'Tiếng Việt' : 'English'}</span>
        </button>

        {/*Header part1*/}
        <img
          alt={"logo"}
          className={"imgHomePage"}
          src={images.logo}
        />

        {/*Header part2*/}
        <div className={'headerPart2'}>
          <span className={'textTitleHeader'}>{appString.titleHeader}</span>
          <span className={'textShortDescription'}>{appString.shortDescription}</span>
          <div className={'viewDownloadApp'}>
            <img
              alt={"AppScreen"}
              className={"imgQrCode"}
              src={images.qrCode}
            />
            <div className={'viewWrapBtnDownloadApp'}>
              {/*App store*/}
              <button
                className={'btnDownloadAppStore'}
                onClick={() => window.open("https://apps.apple.com/app/id1492780477", '_blank')}
              >
                <IconContext.Provider value={{color: 'white', size: "30px"}}>
                  <FaAppStore/>
                </IconContext.Provider>
                <div className={'viewWrapTextBtn'}>
                  <span className={'textBtn1'}>{appString.downloadAppOn}</span>
                  <span className={'textBtn2'}>APP STORE</span>
                </div>
              </button>
              {/*Google play*/}
              <button
                className={'btnDownloadGooglePlay'}
                onClick={() => window.open("https://play.google.com/store/apps/details?id=com.duytq.nubo", '_blank')}
              >
                <IconContext.Provider value={{color: 'white', size: "30px"}}>
                  <FaGooglePlay/>
                </IconContext.Provider>
                <div className={'viewWrapTextBtn'}>
                  <span className={'textBtn1'}>{appString.downloadAppOn}</span>
                  <span className={'textBtn2'}>GOOGLE PLAY</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderDescription = () => {
    const appString = this.state.isEn ? appStringEn : appStringVi
    return (
      <div className={'viewDescription'}>
        <span className={'titleSession'}>{appString.introduce}</span>
        <div className="viewWrapTextDescriptionHeader">
          {appString.descriptionHeader.map(item => {
            return <span className={'textDescriptionHeader'}>{item}</span>
          })}
        </div>
      </div>
    )
  }

  renderFeature = () => {
    const appString = this.state.isEn ? appStringEn : appStringVi
    const appStringBody = appString.mainFeature.body
    const appStringNutrition = appString.mainFeature.nutrition
    return (
      <div className={'viewFeature'}>
        <div className={'viewFeatureColumn1'}>
          <span className={'titleSession'}>{appString.body}</span>
          <div className={'viewFeatureColumnChild'}>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <IoIosBeer/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[0])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[0])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <GiFat/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[1])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[1])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <IoMdCalendar/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[2])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[2])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <FaHeartbeat/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[3])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[3])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <MdCheck/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[4])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[4])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <GiOpenedFoodCan/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[5])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[5])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <FaFireAlt/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[6])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[6])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <IoIosWater/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[7])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[7])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <IoMdBody/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[8])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[8])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <FiPercent/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[9])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[9])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <MdAirlineSeatLegroomNormal/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[10])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[10])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <FaEgg/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[11])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[11])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <MdPregnantWoman/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringBody[12])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringBody[12])}
                                </span>
              </div>
            </div>
          </div>
        </div>

        <div className={'viewVerticalLine'}/>

        <div className={'viewFeatureColumn2'}>
          <span className={'titleSession'}>{appString.nutrition}</span>
          <div className={'viewFeatureColumnChild'}>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <FaTable/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringNutrition[0])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringNutrition[0])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <IoIosCalculator/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringNutrition[1])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringNutrition[1])}
                                </span>
              </div>
            </div>
            <div className={'viewItemFeature'}>
              <div className={'viewWrapIconItemFeature'}>
                <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
                  <FaChartArea/>
                </IconContext.Provider>
              </div>
              <div className={'viewWrapTextItemFeature'}>
                                <span className={'textTitleItemFeature'}>
                                    {Object.keys(appStringNutrition[2])}
                                </span>
                <span className={'textDescriptionItemFeature'}>
                                    {Object.values(appStringNutrition[2])}
                                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderScreenshotBody = () => {
    const appString = this.state.isEn ? appStringEn : appStringVi
    const screenshot = this.state.isEn ? images.screenshot.en : images.screenshot.vi
    const listScreenshot = [
      {text: Object.keys(appString.mainFeature.body[0]), image: screenshot.bac},
      {text: Object.keys(appString.mainFeature.body[1]), image: screenshot.fatRatio},
      {text: Object.keys(appString.mainFeature.body[2]), image: screenshot.biologicalAge},
      {text: Object.keys(appString.mainFeature.body[3]), image: screenshot.checkingHealth},
      {text: Object.keys(appString.mainFeature.body[4]), image: screenshot.checkingSymptom},
      {text: Object.keys(appString.mainFeature.body[5]), image: screenshot.bmr},
      {text: Object.keys(appString.mainFeature.body[6]), image: screenshot.caloBurn},
      {text: Object.keys(appString.mainFeature.body[7]), image: screenshot.waterRequire},
      {text: Object.keys(appString.mainFeature.body[8]), image: screenshot.bmi},
      {text: Object.keys(appString.mainFeature.body[9]), image: screenshot.whr},
      {text: Object.keys(appString.mainFeature.body[10]), image: screenshot.skelie},
      {text: Object.keys(appString.mainFeature.body[11]), image: screenshot.ovulationDay},
      {text: Object.keys(appString.mainFeature.body[12]), image: screenshot.weightPregnancy},
    ]
    const menu = Menu(listScreenshot)
    return (
      <div className={'viewScreenshotBody'}>
        <ScrollMenu
          data={menu}
          arrowLeft={this.renderArrowLeft()}
          arrowRight={this.renderArrowRight()}
          wheel={false}
          dragging={false}
        />
      </div>
    )
  }

  renderScreenshotNutrition = () => {
    const appString = this.state.isEn ? appStringEn : appStringVi
    const screenshot = this.state.isEn ? images.screenshot.en : images.screenshot.vi
    const listScreenshot = [
      {text: Object.keys(appString.mainFeature.nutrition[0]), image: screenshot.nutritionTable},
      {text: Object.keys(appString.mainFeature.nutrition[0]), image: screenshot.detailFood},
      {text: Object.keys(appString.mainFeature.nutrition[1]), image: screenshot.calculateMeal},
      {text: Object.keys(appString.mainFeature.nutrition[2]), image: screenshot.nutritionStatistic},
      {text: Object.keys(appString.mainFeature.nutrition[2]), image: screenshot.nutritionStatistic2},
    ]
    const menu = Menu(listScreenshot)
    return (
      <div className={'viewScreenshotNutrition'}>
        <ScrollMenu
          data={menu}
          arrowLeft={this.renderArrowLeft()}
          arrowRight={this.renderArrowRight()}
          wheel={false}
          dragging={false}
        />
      </div>
    )
  }

  renderViewContact = () => {
    const appString = this.state.isEn ? appStringEn : appStringVi
    return (
      <div className={'viewContact'}>
        <span className={'titleSession'}>{appString.pleaseContact}</span>
        <div className={'viewWrapBtnContact'}>
          <button
            className={'btnContact'}
            onClick={() => window.open("https://www.facebook.com/NuboApp/", '_blank')}
          >
            <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
              <FaFacebookSquare/>
            </IconContext.Provider>
          </button>

          <button className={'btnContact'}>
            <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
              <FaTwitterSquare/>
            </IconContext.Provider>
          </button>

          <button className={'btnContact'}>
            <IconContext.Provider value={{color: '#5BB12F', size: "30px"}}>
              <FaInstagram/>
            </IconContext.Provider>
          </button>
        </div>
      </div>
    )
  }

  renderFooter = () => {
    const appString = this.state.isEn ? appStringEn : appStringVi
    return (
      <div className={'viewFooter'}>
                <span
                  className={'textViewFooter'}
                  onClick={() => this.props.history.push({
                    pathname: './bao-mat-thong-tin',
                    state: {isEn: this.state.isEn}
                  })}
                >
                    {appString.privacyPolicy.title}
                </span>
        <span
          className={'textViewFooter'}
          onClick={() => this.props.history.push({
            pathname: './mien-tru-trach-nhiem',
            state: {isEn: this.state.isEn}
          })}
        >
                    {appString.liabilityWaiver.title}
                </span>
        <span
          className={'textViewFooter'}
          onClick={() => window.open("https://duytq94.github.io/", '_blank')}
        >
                    {`${appString.developer}: Trần Quang Duy`}
                </span>
        <span
          className={'textViewFooter'}
          onClick={() => window.location.href = `mailto:tranquangduy7994@gmail.com`}
        >
                    {`${appString.emailContact}: tranquangduy7994@gmail.com`}
                </span>
      </div>
    )
  }

  renderArrowLeft = () => {
    return (
      <button className={'btnArrow'}>
        <IconContext.Provider value={{color: 'white', size: "30px"}}>
          <IoIosArrowBack/>
        </IconContext.Provider>
      </button>
    )
  }

  renderArrowRight = () => {
    return (
      <button className={'btnArrow'}>
        <IconContext.Provider value={{color: 'white', size: "30px"}}>
          <IoIosArrowForward/>
        </IconContext.Provider>
      </button>
    )
  }

}

const Menu = (list) =>
  list.map((item, index) => {
    return <MenuItem text={item.text} image={item.image} key={index}/>
  })

const MenuItem = ({text, image}) => {
  return (
    <div className={'viewWrapItemScreenshot'}>
      <span className={'textTitleItemScreenshot'}>{text}</span>
      <img
        alt={"AppScreen"}
        className={"imgScreenshot"}
        src={image}
      />
    </div>
  )
}
